import { defineMessages } from 'react-intl';

export default defineMessages({
  mergeConflicts: {
    id: 'frontbucket.repository.pullrequest.fileTree.mergeConflicts',
    description:
      'Tooltip description for merge conflict icon in the tab item for files',
    defaultMessage:
      '{total, plural, one {{total} merge conflict} other {{total} merge conflicts}}',
  },
  details: {
    id: 'frontbucket.repository.pullrequest.tabs.details',
    description: 'Label for details sidebar tab',
    defaultMessage: 'Details',
  },
  files: {
    id: 'frontbucket.repository.pullrequest.tabs.files',
    description: 'Label for files sidebar tab',
    defaultMessage: 'Files',
  },
  activity: {
    id: 'frontbucket.repository.pullrequest.tabs.activity',
    description: 'Label for activity sidebar tab',
    defaultMessage: 'Activity',
  },
});
